module.exports = __webpack_public_path__ + "img/1278689155.6b0b10d8.jpg";